/*
 * Mobile menu: a sub-menu opens underneath its item and closes on a second tap (like Maison Vallier),
 * instead of the theme's sliding panel. Runs in the capture phase so the theme's own handler never sees
 * the tap. Styles in assets/cp-mobile-menu.css.
 */

document.addEventListener('click', (event) => {
  const button = event.target.closest('header-drawer.drawer--header mobile-sliderule > button.sliderow');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const sliderule = button.parentElement;
  const open = !sliderule.classList.contains('cp-open');
  sliderule.classList.toggle('cp-open', open);
  button.setAttribute('aria-expanded', String(open));
}, true);
